<template>
	<div class="chat-item" :class="[active ? 'active' : '',{ 'is-pinned': isPinned }]" @contextmenu.prevent="showRightMenu($event)">
		<div class="chat-left">
			<head-image :url="chat.faceURL" :name="chat.showName" :size="42"
				:id="chat.conversationID" :isShowUserInfo="false" :online="online"></head-image>
			<div v-show="!chat.isDnd && chat.unreadCount > 0" class="unread-text">{{ chat.unreadCount }}</div>
		</div>
		<div class="chat-right">
			<div class="chat-name">
				<div class="chat-name-text">
					<div v-if="!isEditingRemark" class="name-label" @dblclick="startEditRemark">{{ remarkOrNameWithCount }}</div>
					<input v-else v-model="editRemark" @blur="saveRemark"
						@keyup.enter="saveRemark" @keyup.esc="cancelEditRemark" 
						ref="remarkInput" class="remark-edit-input"
					/>
					<el-tag v-if="chatTypeTag" :type="chatTypeTag.type" size="mini" effect="dark" class="conv-type-tag">{{ chatTypeTag.label }}</el-tag>
				</div>
				<div class="chat-time-text">{{ showTime }}</div>
			</div>
			<div class="chat-content">
				<div class="chat-at-text">{{ atText }}</div>
				<div class="chat-send-name" v-show="isShowSendName">{{ chat.sendNickName + ':&nbsp;' }}</div>
				<div class="chat-content-text"
					v-html="$emo.transform($str.html2Escape(chat.latestMsg), 'emoji-small')"></div>
				<div class="icon iconfont icon-dnd" v-if="chat.isDnd"></div>
			</div>
		</div>
		<i class="pin-icon" v-if="isPinned" title="已置顶">
			<svg viewBox="0 0 24 24" width="12" height="12"><path fill="currentColor" d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"/></svg>
		</i>
		<!-- <right-menu ref="rightMenu" @select="onSelectMenu"></right-menu> -->
		<right-menu v-show="rightMenu.show" :pos="rightMenu.pos" :items="menuItems"
			@close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
		<!-- 分组选择弹窗 -->
		<el-dialog
			title="选择分组"
			:visible.sync="showGroupSelectDialog"
			width="300px"
			:before-close="handleCloseGroupDialog"
		>
			<el-select v-model="selectedGroupForMove" placeholder="请选择分组" style="width: 100%">
				<el-option
					v-for="group in availableGroups"
					:key="group.id"
					:label="group.label"
					:value="group.id"
				>
				</el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showGroupSelectDialog = false">取 消</el-button>
				<el-button type="primary" @click="moveToGroup">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';
import { pinnedConversation, remarkConversation, deleteConversation, markConversationGroup } from '../../api/conversation.js';
import { SYSTEM_GROUPS } from '../../utils/conversation.js';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {
			rightMenu: {
				show: false,
				pos: {
					x: 0,
					y: 0
				}
			},
			// 备注功能
			isEditingRemark: false,
            editRemark: '',
			// 分组选择相关
			showGroupSelectDialog: false,
			selectedGroupForMove: 0
		}
	},
	props: {
		chat: {
			type: Object
		},
		active: {
			type: Boolean
		},
		index: {
			type: Number
		},
		isPinned: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		showRightMenu(e) {
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = true;
		},
		onSelectMenu(item) {
			if (item.key.toLowerCase() == 'remark') {
				// 备注逻辑
				this.startEditRemark();
			}else if (item.key.toLowerCase() == 'top'){
				// 置顶处理
				this.setPinned();
			}else if (item.key.toLowerCase() == 'delete') {
				// 删除处理
				this.deleteChat();
			} else if (item.key.toLowerCase() == 'movetogroup') {
				// 移动到分组
				this.showGroupSelectDialog = true;
				this.selectedGroupForMove = this.chat.groupLabelID || 0;
			} else if (item.key.toLowerCase() == 'dnd') {
				// 屏蔽/恢复群消息（消息免打扰），由会话列表页调用接口并更新状态
				this.$emit('dnd', this.chat);
			}				
		},
		startEditRemark() {
			this.editRemark = this.chat.remark || '';
			this.isEditingRemark = true;
			this.$nextTick(() => {
				this.$refs.remarkInput.focus();
			});
    	},
		// 置顶
		setPinned() {
			// 调用API置顶
			pinnedConversation({conversationID: this.chat.conversationID, isPinned: this.isPinned ? false : true}).then(() => {
				// 更新存储
				this.chatStore.setPinned(this.index);
				// this.$message.success('置顶更新');
			}).catch(err => {
				this.$message.error('置顶失败: ' + err.message);
			});
		},
		// 备注
		saveRemark() {
			if (this.editRemark.trim() === '') {
				this.cancelEditRemark();
				return;
			}
			// 调用API保存备注
			remarkConversation({conversationID: this.chat.conversationID, remark: this.editRemark.trim()}).then(() => {
				// 更新存储
				this.chatStore.remarkChat({
					conversationID: this.chat.conversationID,
					remark: this.editRemark.trim(),
				});
				this.$message.success('备注已更新');
			}).catch(err => {
				this.$message.error('更新备注失败: ' + err.message);
			}).finally(() => {
				this.isEditingRemark = false;
			});
		},
		// 取消备注
		cancelEditRemark() {
			this.isEditingRemark = false;
		},
		// 删除会话
		deleteChat() {
			// 调用API删除会话
			deleteConversation({conversationID: this.chat.conversationID}).then(() => {
				// 更新存储
				this.chatStore.removeChat(this.index);
				this.$message.success('删除会话成功');
			}).catch(err => {
				this.$message.error('删除会话失败: ' + err.message);
			});
		},
		// 移动到分组
		moveToGroup() {
			if (this.selectedGroupForMove === null || this.selectedGroupForMove === undefined) {
				this.$message.warning('请选择分组');
				return;
			}
			// 判断分组是否是原来的组
			if ((this.chat.groupLabelID || 0) === this.selectedGroupForMove) {
				this.$message.warning('请选择不同的分组');
				return
			}
			// 调用API移动会话到分组
			markConversationGroup({
					conversationID: this.chat.conversationID,
					groupLabelID: this.selectedGroupForMove
				}).then(() => {
				// 更新存储
				this.chatStore.markChatToGroup({
					conversationID: this.chat.conversationID,
					groupLabelID: this.selectedGroupForMove
				});
				const groupName = this.availableGroups.find(g => g.id === this.selectedGroupForMove)?.label || '未知分组';
				this.$message.success(`已移动到 ${groupName}`);	
			}).catch(err => {
				this.$message.error('移动失败: ' + err.message);
			}).finally(() => {
				this.showGroupSelectDialog = false;
			});
		},
		// 关闭分组选择对话框
		handleCloseGroupDialog(done) {
			this.selectedGroupForMove = 0;
			done();
		}
	},
	computed: {
		isShowSendName() {
			if (!this.chat.sendNickName) {
				return false;
			}
			if (!Array.isArray(this.chat.messages) || this.chat.messages.length === 0) {
				return this.$msgType.isNormal(this.chat.latestMsgType);
			}
			// 只有群聊的普通消息需要显示名称
			let lastMsg = this.chat.messages[this.chat.messages.length - 1];
			return this.$msgType.isNormal(lastMsg.msgType)
		},
		showTime() {
			// return this.$date.toTimeText(this.chat.lastSendTime, true)
			return this.$date.toTimeText(this.chat.latestMsgSendTime * 1000, true)
		},
		atText() {
			if (this.chat.atMe) {
				return "[有人@我]"
			} else if (this.chat.atAll) {
				return "[@全体成员]"
			}
			return "";
		},
		remarkOrName() {
      		return this.chat.remark || this.chat.showName;
    	},
		// 群聊名称后追加成员数（如 "测试群(12)"），单聊不显示
		remarkOrNameWithCount() {
			let name = this.remarkOrName;
			if (this.chat.convType === 'group' && this.chat.groupMemberCount > 0) {
				return `${name}(${this.chat.groupMemberCount})`;
			}
			return name;
		},
		chatTypeTag() {
			if (this.chat.convType === 'group') {
				return { label: '群聊', type: 'warning' };
			}
			if (this.chat.convType === 'single' && this.chat.scene === 'internal') {
				return { label: '内部', type: 'primary' };
			}
			if (this.chat.convType === 'single' && this.chat.scene === 'customer_service') {
				return { label: '个微', type: 'success' };
			}
			return null;
		},
		// menuItems() {
		// 	let items = [];
		// 	items.push({
		// 		key: 'TOP',
		// 		name: '置顶'
		// 	});
		// 	if (this.chat.isDnd) {
		// 		items.push({
		// 			key: 'DND',
		// 			name: '新消息提醒'
		// 		})
		// 	} else {
		// 		items.push({
		// 			key: 'DND',
		// 			name: '消息免打扰'
		// 		})
		// 	}
		// 	items.push({
		// 		key: 'DELETE',
		// 		name: '删除聊天',
		// 		color: '#F56C6C'
		// 	})
		// 	return items;
		// },
		menuItems() {
			const baseItems = [
				{
					key: 'REMARK',
					name: '备注',
					icon: 'el-icon-edit'
				},
				{
					key: 'MOVETOGROUP',
					name: '分组',
					icon: 'el-icon-folder'
				},
				{
					key: 'DELETE',
					name: '删除',
					icon: 'el-icon-delete'
				}
			];
    
			const pinItem = {
				key: 'TOP',
				name: this.isPinned ? '取消置顶' : '置顶',
				icon: this.isPinned ? 'el-icon-bottom' : 'el-icon-top'
			};
    
			// 屏蔽群消息（消息免打扰）仅群聊会话显示，单聊沿用行内字段体系未启用
			const dndItem = {
				key: 'DND',
				name: this.chat.isDnd ? '恢复消息提醒' : '屏蔽群消息',
				icon: this.chat.isDnd ? 'el-icon-bell' : 'el-icon-close'
			};
			const items = [pinItem, ...baseItems];
			if (this.chat.convType === 'group') {
				items.splice(items.length - 1, 0, dndItem);
			}
    		return items;
  		},
		// 获取所有可用分组
		availableGroups() {
			return [
				{ ...SYSTEM_GROUPS.DEFAULT },
				...this.chatStore.chatLabels.filter(l => l.id > 0)
			];
		},
		online() {
			if (this.chat.convType === 'single') {
				let friend = this.friendStore.findFriend(this.chat.personalUserID);
				return friend && friend.online;
			}
				return false;
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-item {
	height: 56px;
	display: flex;
	position: relative;
	margin: 0 3px;
	padding: 5px 8px;
	align-items: center;
	background-color: var(--im-background);
	white-space: nowrap;
	cursor: pointer;
	border-radius: 10px;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color: var(--im-background-active-dark);
	}

	// 置顶会话：浅灰底与普通会话区分（选中/悬停态优先级更高）
	&.is-pinned {
		background-color: var(--im-background-pinned);

		&:hover {
			background-color: var(--im-background-active);
		}

		&.active {
			background-color: var(--im-background-active-dark);
		}

		// 时间文本右侧让位给右上角图钉
		.chat-time-text {
			padding-right: 14px;
		}
	}

	// 置顶图钉：右上角角标（不参与 flex 布局，不挤压内容）
	.pin-icon {
		position: absolute;
		top: 4px;
		right: 5px;
		display: inline-flex;
		width: 12px;
		height: 12px;
		color: var(--im-text-color-lighter);
		z-index: 1;
	}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		.unread-text {
			position: absolute;
			background-color: #f56c6c;
			right: -4px;
			top: -8px;
			color: white;
			border-radius: 30px;
			padding: 1px 5px;
			font-size: 10px;
			text-align: center;
			white-space: nowrap;
			border: 1px solid #f1e5e5;
		}
	}


	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			line-height: 26px;
			height: 26px;

			.chat-name-text {
				flex: 1;
				display: flex;
				align-items: center;
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;
				min-width: 0;

				.name-label {
					overflow: hidden;
					text-overflow: ellipsis;
					min-width: 0;
				}

				.conv-type-tag {
					margin-left: 4px;
					flex-shrink: 0;
					transform: scale(0.85);
				}
			}

			.chat-time-text {
				font-size: var(--im-font-size-smaller);
				text-align: right;
				color: var(--im-text-color-light);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 10px;
			}
		}

		.chat-content {
			display: flex;
			line-height: 24px;

			.chat-at-text {
				color: #c70b0b;
				font-size: var(--im-font-size-smaller);
			}

			.chat-send-name {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
			}

			.chat-content-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
			}

			.icon {
				color: var(--im-text-color-light);
			}
		}
	}
}
</style>
